import {Injectable} from "@angular/core";
import {PromotedFeatureEnum} from "~/app/domains/onboarding/enums/promoted-feature.enums";
import {
    PromotedFeature,
} from "~/app/domains/onboarding/types/promoted-feature.type";
import {PROMOTED_FEATURES} from "~/app/domains/onboarding/constants/promoted-features.constant";

@Injectable({
    providedIn: 'root'
})
export class NewFeaturePopInService {

    public getPromotedFeatures(promotedFeaturesIds: PromotedFeatureEnum[]) {
        const promotedFeatures: PromotedFeature[] = [];

        promotedFeaturesIds.forEach((promotedFeatureId) => {
            const promotedFeature = PROMOTED_FEATURES.find(y => y.id === promotedFeatureId);
            if (promotedFeature) {
                promotedFeatures.push(promotedFeature);
            }
        })
        return promotedFeatures;
    }
}
